import React from 'react';
import { Outlet } from 'react-router-dom';
import { InstrumentProvider } from './instrument.ctx';

export default () => (
  <InstrumentProvider>
    <Outlet />
  </InstrumentProvider>
);
